// src/components/CustomSnackbar.jsx - Versión optimizada
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Alert } from 'react-bootstrap';

export default function CustomSnackbar({ type = 'info', message = '', onClose, open = false }) {
  const [show, setShow] = useState(open);
  const timerRef = useRef(null);
  const onCloseRef = useRef(onClose);

  // Mantener la referencia actualizada sin causar re-renders
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  // Sincronizar con la prop open
  useEffect(() => {
    setShow(open);
  }, [open]);

  // Manejar el auto-cierre - solo depende de 'show'
  useEffect(() => {
    // Limpiar timer anterior si existe
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (show) {
      timerRef.current = setTimeout(() => {
        setShow(false);
        // Usar la referencia para evitar dependencias
        if (onCloseRef.current) {
          onCloseRef.current();
        }
      }, 6000);
    }

    // Cleanup function
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [show]); // Solo depende de 'show', no de 'onClose'

  // Función para cerrar manualmente
  const handleClose = useCallback(() => {
    // Limpiar timer si existe
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    
    setShow(false);
    if (onCloseRef.current) {
      onCloseRef.current();
    }
  }, []); // Sin dependencias

  // Si no se está mostrando, no renderizamos nada
  if (!show) {
    return null;
  }

  // Mapear tipo a variante de Bootstrap
  const variant = mapTypeToVariant(type);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        maxWidth: '80%'
      }}
    >
      <Alert 
        variant={variant} 
        onClose={handleClose}
        dismissible
      >
        {message}
      </Alert>
    </div>
  );
}

// Mapea el "type" recibido a un variant de Bootstrap
function mapTypeToVariant(type) {
  switch (type) {
    case 'success':
      return 'success';
    case 'error':
      return 'danger';
    case 'warning':
      return 'warning';
    case 'info':
      return 'info';
    default:
      return 'primary';
  }
}